/* @flow */

type State = {
    +reservationStart: Array,
    +reservationComplete: Array,
    stateTransition: Array,
    couponSubmission: Array,
};

let initialState = {
    reservationStart: [],
    reservationComplete: [],
    stateTransition: [],
    couponSubmission: [],
};

export function hooks(state: State = initialState, action): State {
    if(action.type === "ADD_RESERVATION_START_HOOK") {
        let newState = {...state};
        newState.reservationStart.push(action.hook);
        return newState;
    } else if(action.type === "RESERVATION_CREATED") {
        for(let i = 0; i < state.reservationStart.length; i++) {
            state.reservationStart[i]();
        }

        return state;
    } else if(action.type === "RESERVATION_COMPLETED") {
        for(let i = 0; i < state.reservationComplete.length; i++) {
            state.reservationComplete[i]();
        }

        return state;
    } else if(action.type === "ADD_RESERVATION_COMPLETE_HOOK") {
        let newState = {...state};
        newState.reservationComplete.push(action.hook);
        return newState;
    } else if(action.type === "ADD_STATE_COUPON_SUBMISSION_HOOK") {
        let newState = {...state};
        newState.couponSubmission.push(action.hook);
        return newState;
    } else if(action.type === "ADD_STATE_TRANSITION_HOOK") {
        let newState = {...state};
        newState.stateTransition.push(action.hook);
        return newState;
    } else if(action.type === "@ui-router/FINISH_TRANSITION") {
        let page = action.transition._targetState._definition.name;
        // ticketPicker fires when the picker is still invisible, it's handled elsewhere
        // checkout is handled by the step seen trigger below
        if(page === 'ticketPicker' || page === "checkout") {
            return state;
        }

        for(let i = 0; i < state.stateTransition.length; i++) {
            state.stateTransition[i](page);
        }
        return state;
    } else if(action.type === "TICKET_PICKER_OPENED") {
        for(let i = 0; i < state.stateTransition.length; i++) {
            state.stateTransition[i]('ticketPicker');
        }
        return state;
    } else if(action.type === "CHECKOUT_STEP_SEEN") {
        let page = 'checkout-' + (action.index + 1);
        for(let i = 0; i < state.stateTransition.length; i++) {
            state.stateTransition[i](page);
        }
        return state;
    } else if(action.type === "COUPON_SUBMITTED") {
        for(let i = 0; i < state.couponSubmission.length; i++) {
            state.couponSubmission[i](action.code);
        }
        return state;
    } else {
        return state;
    }
}
